/**
 * Issue Item API Client
 * Connects directly to FastAPI backend /admission/issue-item endpoints.
 * 100% Zero Mock Data - Full Backend Integration.
 */
import api from '../../../../api/client'

/**
 * Fetch dropdown options for issue item form & filters
 */
export async function fetchIssueOptions() {
  const { data } = await api.get('/admission/issue-item/options')
  return data
}

/**
 * List issued items with server-side filtering and pagination
 */
export async function listIssuedItems(params = {}) {
  const { data } = await api.get('/admission/issue-item/list', { params })
  return data
}

/**
 * Get a single issue transaction by id
 */
export async function getIssueTransaction(id) {
  const { data } = await api.get(`/admission/issue-item/${id}`)
  return data
}

/**
 * Get eligible students based on item, course, batch, and fee eligibility criteria
 */
export async function getStudentsForIssue(params = {}) {
  const { data } = await api.get('/admission/issue-item/eligible-students', { params })
  return data
}

/**
 * Create a new issue transaction
 */
export async function createIssueTransaction(payload) {
  const { data } = await api.post('/admission/issue-item', payload)
  return data
}

/**
 * Update an existing issue transaction
 */
export async function updateIssueTransaction(id, payload) {
  const { data } = await api.put(`/admission/issue-item/${id}`, payload)
  return data
}

/**
 * Soft delete an issue transaction
 */
export async function deleteIssueTransaction(id) {
  const { data } = await api.delete(`/admission/issue-item/${id}`)
  return data
}
